import {throttle} from '../modules/throttle';

/* DEPRECATED */

var reloadingIframe = function(el){
    var iframe = el.querySelector('[data-reloadingIframe-iframe]'),
        progressEl = el.querySelector('[data-reloadingIframe-progress]'),
        stopTime = false,
        durTimeMs = 30000,
        pastTimeMs = 0,
        startTimeMs = 0,
        checkVisibility = function(){
            var rect = iframe.getBoundingClientRect(),
                midY = rect.top + rect.height/2,
                midX = rect.left + rect.width/2;

            return (
                midY > 0 &&
                midX > 0 &&
                midY < (window.innerHeight || document.documentElement.clientHeight) &&
                midX < (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        checkReload = function(){
            if(checkVisibility()){
                if(!stopTime){
                    startTimeMs = Date.now();
                    var leftTimeMs = durTimeMs - pastTimeMs;
                    progressEl.style.cssText = 'width:100%;transition-duration:'+ leftTimeMs +'ms';

                    //console.log('Старт интервала, оставшееся время показа', leftTimeMs);

                    stopTime = setTimeout(function(){
                        iframe.src = iframe.src;
                        pastTimeMs = 0;
                        progressEl.style.cssText = 'width:0%;transition-duration:0ms';
                        stopTime = false;
                        checkReload();
                        //console.log('Reload iframe', leftTimeMs);
                    }, leftTimeMs);
                }
            }
            else {
                if(stopTime){
                    clearTimeout(stopTime);
                    stopTime = false;
                    pastTimeMs += Date.now() - startTimeMs;
                    progressEl.style.cssText = 'width:'+ pastTimeMs/durTimeMs*100 +'%;transition-duration:0ms';
                    //console.log('Остановка pastTimeMs',  pastTimeMs);
                }
            }
        },
        init = function(){
            throttle('scroll', checkReload);
            throttle('resize', checkReload);
            checkReload();
        };

    //
    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener('load', init);
    }
}

export {reloadingIframe};
